import { FC, PropsWithChildren } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import { SiteHeader } from "@/components/site-header";
import CredentialExpiryBanner from "@/components/CloudProvider/CredentialExpiryBanner";

const MainLayout: FC<PropsWithChildren<{}>> = ({ children }) => {
  return (
    <div className="flex bg-white h-screen overflow-hidden">
      <Sidebar />
      <div className="flex flex-col flex-1 bg-white overflow-hidden">
        <CredentialExpiryBanner />
        <SiteHeader />
        <main className="flex-1 bg-white overflow-auto">
          {children ?? <Outlet />}
        </main>
      </div>
    </div>
  );
};

export default MainLayout;
